import * as yup from "yup";
import { convertDateTimeToString, convertDateToString, convertTimeToString } from "../utility/ConvertUtily";

const now = new Date();
const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
let tempDatetime = new Date();

export type Messages = {
  id: string;
  tenantId: string;
  title: string;
  body: string;
  urlButtonFlg?: boolean;
  urlButtonName?: string;
  urlLink?: string;
  image: string;
  contactInformation?: string;
  eventVenue? : string;
  isMunicipality?: boolean;
  type: string;
  link: string;
  url?: string;
  fileupload: string;
  topic?: string[];
  draftFlg: boolean;
  authorUid: string;
  authorName?: string;
  deliveredFlg: boolean;
  eventFlg: boolean;
  eventAt: Date;
  eventAtTime?: string;
  eventEndAt: Date;
  eventEndAtTime?: string;
  isEventTimeEmpty?: boolean;
  eventType?: string;
  publishEndAt?: Date;
  publishEndAtTime?: string;
  sendDate: Date;
  sendDateTime?: string;
  select?: string;
  regularFlg?: boolean;
  regularSetting?: RegularSetting;
  replyButton?: string;
  createAt: Date;
};

export const newMessage = (): Messages => {
  return  {
    id: "",
    tenantId: "",
    title: "",
    body: "",
    image: "",
    urlButtonName: "",
    urlLink: "",
    contactInformation: "",
    eventVenue: "",
    type: "",
    link: "",
    url: "https://",
    fileupload: "",
    topic: [],
    draftFlg: false,
    authorUid: "",
    deliveredFlg: false,
    eventFlg: false,
    eventAt: nowDate,
    eventEndAt: nowDate,
    eventType: '',
    sendDate: now,
    select: '',
    regularFlg: false,
    regularSetting: {
      repeatIntervalNum: 1,
      repeatIntervalType: 'weekly',
      endDateType: 'none',
    },
    replyButton: '',
    createAt: now,
  };
};

// 繰り返し設定用モデル
// repeatIntervalNum: 繰り返す間隔(number)
// repeatIntervalType: 繰り返す間隔のタイプ(RepeatIntervalType)
// dayOfWeek?: 週間ごとで繰り返す曜日([日,月,火,水,木,金,土])
// everyMonthType?: nか月ごとのタイプ(EveryMonthType)
// endDateType: 配信終了日のタイプ(EndDateType)
// endDate?: 終了日(Date)
// numberOfRepeats?: 回数(number)
// previousDeliveryDate?: イベントの何日前に配信するか設定(number)
export type RegularSetting = {
  repeatIntervalNum: number;
  repeatIntervalType: RepeatIntervalType;
  dayOfWeek?: boolean[];
  everyMonthType?: EveryMonthType;
  endDateType: EndDateType;
  endDate?: Date;
  numberOfRepeats?: number;
  previousDeliveryDate?: number;
};

// 繰り返す間隔のタイプ
// 'daily': 日ごと(不使用)
// 'weekly': 週間ごと
// 'monthly' nか月ごと
// 'yearly' 年ごと(不使用)
export type RepeatIntervalType = 'daily' | 'weekly' | 'monthly' | 'yearly';

// nか月ごとのタイプ
// 'day': 毎月n日
// 'week' 毎月第n w曜日
export type EveryMonthType = 'day' | 'week';

// 繰り返し配信終了日のタイプ
// 'none': なし
// 'endDate': 終了日指定
// 'numberOfRepeats': 回数指定
export type EndDateType = 'none' | 'endDate' | 'numberOfRepeats';

// お知らせ検索用
export type SearchMessage = {
  title: string;
  contactInformation: string;
  select: string;
  sendDateStart: string;
  sendDateEnd: string;
  publishEndAtStart: string;
  publishEndAtEnd: string;
  eventAtStart: string;
  eventAtEnd: string;
  eventFlg: string;
  status: string;
  replyButton: string;
  eventType: string;
  authorName: string;
  topic: {id: string, title: string}[];
  orderBy: string;
  dir: string;
};

// お知らせ検索初期値
export const MessageSearchDefault = (): SearchMessage => {
  return  {
    title: "",
    contactInformation: "",
    select: "",
    sendDateStart: "",
    sendDateEnd: "",
    publishEndAtStart: "",
    publishEndAtEnd: "",
    eventAtStart: "",
    eventAtEnd: "",
    eventFlg: "",
    status: "",
    replyButton: '',
    eventType: '',
    authorName: "",
    topic: [],
    orderBy: "",
    dir: ""
  };
};

// お知らせ取得API用データ作成
export const getMessageSearchData = (data: SearchMessage, checkedValue: string, checkedDate: string) => {
  return {
    title: data.title !== "" && checkedValue === "title" ? data.title : null,
    contactInformation: data.contactInformation !== "" && checkedValue === "contactInformation" ? data.contactInformation : null,
    select: data.select !== "" ? data.select : null,
    groupId: data.select === "topic" ? data.topic.map(t => t.id) : null,
    sendAtStart: data.sendDateStart !== "" && checkedDate === "sendDate" ? new Date(data.sendDateStart + "T00:00:00.000+09:00") : null,
    sendAtEnd: data.sendDateEnd !== "" && checkedDate === "sendDate" ? new Date(data.sendDateEnd + "T23:59:59.000+09:00") : null,
    publishEndAtStart: data.publishEndAtStart !== "" && checkedDate === "publishEndAt" ? new Date(data.publishEndAtStart + "T00:00:00.000+09:00") : null,
    publishEndAtEnd: data.publishEndAtEnd !== "" && checkedDate === "publishEndAt" ? new Date(data.publishEndAtEnd + "T23:59:59.000+09:00") : null,
    eventAtStart: data.eventAtStart !== "" && checkedDate === "eventAt" ? new Date(data.eventAtStart + "T00:00:00.000+09:00") : null,
    eventAtEnd: data.eventAtEnd !== "" && checkedDate === "eventAt" ? new Date(data.eventAtEnd + "T23:59:59.000+09:00") : null,
    eventFlg: data.eventFlg === "message" ? false : data.eventFlg === "schedule" ? true : null,
    status: data.status !== "" ? data.status : null,
    replyButtonId: data.replyButton !== "" ? data.replyButton : null,
    eventType: data.eventType !== "" ? data.eventType : null,
    authorName: data.authorName !== "" ? data.authorName : null,
    orderBy: data.orderBy !== "" ? data.orderBy : null,
    dir: data.dir !== "" ? data.dir : null
  };
};

// 配信日とイベントのモデル
export type SendDateAndEventDateList = {
  sendDate: Date;
  eventAt?: Date;
  eventEndAt?: Date;
  publishEndAt?: Date;
};

// firestoreから取得したデータのマッピング
export const MessageTimestampToDate = (data: any | undefined): Messages => {
  if(data.eventAt !== undefined && data.eventEndAt !== undefined){
    data.eventAt = new Date(data?.eventAt.seconds * 1000);
    data.eventEndAt = new Date(data?.eventEndAt.seconds * 1000);
  }
  data.sendDate = new Date(data?.sendDate.seconds * 1000);
  data.createAt = new Date(data?.createAt.seconds * 1000);
  if(data.publishEndAt !== undefined){
    data.publishEndAt = new Date(data?.publishEndAt?.seconds * 1000);
  }
  if(data.regularSetting !== undefined && data.regularSetting.endDate !== undefined){
    data.regularSetting.endDate = new Date(data.regularSetting.endDate * 1000);
  }
  return data;
}

// rdbから取得したお知らせ一覧のデータのマッピング
export const RdbMessageListTimestampToDate = (data: any | undefined): Messages => {
  let messageData: Messages = {
    id: data.id,
    tenantId: data.tenant_id,
    title: data.title,
    body: data.body,
    image: data.image,
    type: data.message_type,
    link: data.link,
    fileupload: data.fileupload,
    replyButton: data.reply_button,
    topic: data.topic,
    draftFlg: data.draft_flg,
    authorUid: data.author_uid,
    authorName: data.author_name,
    deliveredFlg: data.delivered_flg,
    eventFlg: data.event_flg,
    eventAt: data.event_at,
    eventEndAt: data.event_end_at,
    sendDate: data.send_date,
    createAt: data.create_at
  }

  if(messageData.eventAt !== null){
    messageData.eventAt = new Date(data.event_at);
  }
  messageData.sendDate = new Date(data.send_date);
  messageData.createAt = new Date(data.create_at);
  if(data.publish_end_at !== null){
    messageData.publishEndAt = new Date(data.publish_end_at);
  }
  return messageData;
}

// Messagesのサブコレクション（Topic）
export type Topic = {
  id: string;
  tenantId: string;
  messageId: string;
  draftFlg: boolean;
  deliveredFlg: boolean;
  sendDate: Date;
  eventFlg: boolean;
  eventAt: Date | null;
  updateAt?: Date;
};

// firestoreから取得したtopicデータのマッピング
export const TopicTimestampToDate = (data: any | undefined): Topic => {
  data.sendDate = new Date(data?.sendDate.seconds * 1000);
  if(data?.eventAt !== null){
    data.eventAt = new Date(data?.eventAt.seconds * 1000);
  }
  if(data?.updateAt !== undefined){
    data.updateAt = new Date(data?.updateAt.seconds * 1000);
  }
  return data;
}

//Messageのサブコレクション
export type token = {
  userId: string;
};

export const messageSchema = yup.object({
  // タイトル
  title: yup.string().label('タイトル').required(),
  // 配信日
  sendDate: yup.date().label('配信日').required().test((value, testContext) => {
    const sendDateValue = testContext.parent.sendDate;
    const now = new Date();
    const nowDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    )
    if(sendDateValue < nowDate){
      return testContext.createError({
        message: `${convertDateToString(new Date(nowDate.setDate(nowDate.getDate() - 1)))}より後でなければなりません。`
      })
    }
    return true;
  }),
  // 配信時間
  sendDateTime: yup.string().label('配信時間').test((value, testContext) => {
    if (value === "") return true;
    const sendAt = testContext.parent.sendDate;
    if (sendAt === undefined) return true;
    const now = new Date();
    const nowDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    )
    const sendAtDate = new Date(
      sendAt.getFullYear(),
      sendAt.getMonth(),
      sendAt.getDate()
    )
    if (sendAtDate.getTime() === nowDate.getTime()) {
      const nowDateTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes()
      )
      const sendAtTime = new Date(
        sendAt.getFullYear(),
        sendAt.getMonth(),
        sendAt.getDate(),
        Number(value?.substring(0,2)),
        Number(value?.substring(3))
      )
      if(sendAtTime < nowDateTime){
        return testContext.createError({
          message: `${convertTimeToString(new Date(nowDateTime.setMinutes(nowDateTime.getMinutes() - 1)))}より後でなければなりません。`,
        })
      }
    }
    return true;
  }),
  // 掲載終了日
  publishEndAt: yup.date().label('掲載終了日').test((value, testContext) => {
    const publishEndAtValue = testContext.parent.publishEndAt;
    const eventFlg = testContext.parent.eventFlg;
    const eventAtValue = testContext.parent.eventAt;
    const sendDateValue = testContext.parent.sendDate;
    if(publishEndAtValue !== undefined){
      let comparisonTarget = null;
      const now = new Date();
      const nowDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      )
      const sendDate = new Date(
        sendDateValue.getFullYear(),
        sendDateValue.getMonth(),
        sendDateValue.getDate()
      )
      if (publishEndAtValue < nowDate) {
        comparisonTarget = new Date(nowDate.setDate(nowDate.getDate() - 1));
      } else if (publishEndAtValue < sendDate) {
        comparisonTarget = new Date(sendDate.setDate(sendDate.getDate() - 1));
      } else if (eventFlg && publishEndAtValue <= eventAtValue) {
        comparisonTarget = eventAtValue;
      }
      if (comparisonTarget !== null) {
        return testContext.createError({
          message: `${convertDateToString(comparisonTarget)}より後でなければなりません。`
        })
      }
    }
    return true;
  }),
  // 本文
  body: yup.string().label('本文').required(),
  // 繰り返し配信
  regularFlg: yup.boolean(),
  // 繰り返す間隔
  regularSetting: yup.object().when('regularFlg', {
    is: true,
    then: yup.object({
      repeatIntervalNum: yup.number().positive().required(),
      endDate: yup.date().when('endDateType', {
        is: (val: string) => val === 'endDate',
        then: yup.date().required()
      }),
      numberOfRepeats: yup.number().when('endDateType', {
        is: (val: string) => val === 'numberOfRepeats',
        then: yup.number().positive().required()
      }),
      previousDeliveryDate: yup.number().when('eventFlg', {
        is: true,
        then: yup.number().positive().required()
      })
    })
  }),
  // URLリンクボタン名
  urlButtonName: yup.string().label('URLボタン名')
    .when('urlButtonFlg', {
      is: true,
      then: yup.string().required()
    }),
  // URLリンク
  urlLink: yup.string().url().label('URL')
    .when('urlButtonFlg', {
      is: true,
      then: yup.string().url().required()
    }),
  // 予定表への記載
  eventFlg: yup.boolean(),
  // 開催日時
  eventAt: yup.date().required().label('イベント開催日').when('eventFlg', {
    is: true,
    then: yup.date().when('sendDate', {
      is: (sendDate: Date) => tempDatetime = sendDate,
      then: yup.date().test((value, testContext) => {
        let comparisonTarget = null;
        const now = new Date();
        const nowDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        )
        const eventAt = testContext.parent.eventAt;
        const eventStartDate = new Date(
          eventAt.getFullYear(),
          eventAt.getMonth(),
          eventAt.getDate()
        )
        const sendDateValue = testContext.parent.sendDate;
        const sendDate = new Date(
          sendDateValue.getFullYear(),
          sendDateValue.getMonth(),
          sendDateValue.getDate()
        )
        if(eventStartDate <= nowDate){
          comparisonTarget = nowDate;
        } else if (eventStartDate <= sendDate) {
          comparisonTarget = sendDate;
        }
        if (comparisonTarget !== null) {
          return testContext.createError({
            message: `${convertDateToString(comparisonTarget)}より後でなければなりません。`
          })
        }
        return true;
      })
    })
  }),
  // 開始時間
  eventAtTime: yup.string().label('開始時間').when('eventFlg', {
    is: true,
    then: yup.string().when('sendDate', {
      is: (sendDate: Date) => tempDatetime = sendDate,
      then: yup.string().required().test((value, testContext) => {
        const tempDatetimeAt = new Date(
          tempDatetime.getFullYear(),
          tempDatetime.getMonth(),
          tempDatetime.getDate()
        )
        const eventAt = testContext.parent.eventAt;
        const eventStartAt = new Date(
          eventAt.getFullYear(),
          eventAt.getMonth(),
          eventAt.getDate()
        )
        const eventStartAtTime = new Date(
          eventAt.getFullYear(),
          eventAt.getMonth(),
          eventAt.getDate(),
          Number(value?.substring(0,2)),
          Number(value?.substring(3))
        )
        let today = new Date();
        const todayAt = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        )
        if(eventStartAt >= tempDatetimeAt){
          if(eventStartAtTime < tempDatetime){
            if(todayAt.toDateString() === eventStartAt.toDateString()){
              return testContext.createError({
                message: `${convertTimeToString(tempDatetime)}より後でなければなりません。`,
              })
            }
          }
        }
        return true;
      })
    })
  }),
  // 終了日時
  eventEndAtTime: yup.string().label('終了時間').when('eventFlg', {
    is: true,
    then: yup.string().required().test((value, testContext) => {
      const eventAtTime = testContext.parent.eventAtTime;
      let today = new Date();
      const eventStartAt = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Number(eventAtTime?.substring(0,2)),
        Number(eventAtTime?.substring(3))
      )
      const eventEndAt = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Number(value?.substring(0,2)),
        Number(value?.substring(3))
      )
      if(eventStartAt >= eventEndAt){
        return testContext.createError({
          message: `${eventAtTime}より後でなければなりません。`
        })
      }
      return true;
    })
  }),
  // ミーティングURL直接入力
  url: yup.string().when('eventFlg', {
    is: true,
    then: yup.string().when('link', {
      is: (link: string) =>  link === '',
      then: yup.string().url().required()
    })
  }),
  // 返信ボタン
  replyButton: yup.string().when('eventFlg', {
    is: true,
    then: yup.string()
      .label('予定表へ記載する場合、返信ボタン')
      .required().test(
      'replyButton',
      (replyButton, _) => {
        if(replyButton === '' || replyButton === undefined || replyButton === "undefined" || replyButton === 'none'){
          return false;
        }
        return true;
      }
    )
  })
});
